export default __webpack_public_path__ + "static/media/24.e8c010e4.jpg";